/** A single delegated person still needs an explicit selection and request scope. */
export function needsTimekeeperSelection(
	options: readonly { sublabel?: string }[],
	currentUserEmail: string | null | undefined,
): boolean {
	if (options.length !== 1) return options.length > 1;
	const email = currentUserEmail?.trim().toLowerCase();
	return !email || options[0].sublabel?.trim().toLowerCase() !== email;
}
